module.exports = {"430271006":"学林街道","430271101":"云田镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430271.json
// module id = 1823
// module chunks = 0